var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"title":"Cart expired","first-button-text":"OK","dark-theme":_vm.darkTheme,"first-button-action":_vm.closeModal},on:{"close":_vm.closeModal}},[_c('div',[_vm._v(" Carts left unattended for 1 hour are automatically abandoned. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }